import type { FC } from 'react';
import { lazy, useMemo } from 'react';
import type { MmsParams } from 'src/apis/iip-service/types';
import type { IipServiceRequest } from 'src/apis/iip-service/use-iip-service';
import { useMms } from 'src/apis/iip-service/use-mms';
import { PageSpinner } from 'src/components/spinner-container';
import type { Successful } from 'src/hooks/use-axios';
import { useMmPageParams } from 'src/pages/market-messages/maintenance-messages/overview/use-page-params';

const Page = lazy(() => import('./page'));

type Props = {
  iipService: Successful<IipServiceRequest>;
};

export const CreateMaintenanceMessage: FC<Props> = ({ iipService }) => {
  const params = useMmPageParams();

  const transformedParams = useMemo(() => {
    const { start, pageSize } = params.value;
    return {
      offset: start,
      limit: pageSize,
    } satisfies MmsParams;
  }, [params.value]);

  const mms = useMms({ iipService, params: transformedParams });

  if (!mms.response) return <PageSpinner />;

  return <Page mms={mms} />;
};
